module.exports = __webpack_public_path__ + "static/media/image_fileholder.0305ea1a.jpg";